import { render, staticRenderFns } from "./SocioAvatar.vue?vue&type=template&id=b43c999c&scoped=true"
import script from "./SocioAvatar.vue?vue&type=script&lang=js"
export * from "./SocioAvatar.vue?vue&type=script&lang=js"
import style0 from "./SocioAvatar.vue?vue&type=style&index=0&id=b43c999c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43c999c",
  null
  
)

export default component.exports